import { RootState } from "../Store";
export const SELECT_REQUEST_ALL_DATA = (state: RootState) => {
  return state.requestAppSlise.data;
};
export const SELECT_REQUEST_BANK = (state: RootState) => {
  return state.requestAppSlise.data.application_banks;
};
export const SELECT_REQUEST_BANK_ID = (state: RootState) => {
  return state.requestAppSlise.data?.bank;
};
export const SELECT_REQUEST_BANK_APPLICATION_STATUS = (state: RootState) => {
  return state.requestAppSlise.data?.bank?.status;
};
export const SELECT_REQUEST_MATCH = (state: RootState) => {
  return state.requestAppSlise.MATCH_DATA;
};
export const SELECT_REQUEST_DOCUMENTS = (state: RootState) => {
  return state.requestAppSlise.data.documents;
};
export const SELECT_REQUEST_DOCUMENTS_COUNT = (state: RootState) => {
  let counts = 0;
  const { documents } = state.requestAppSlise.data;
  documents?.forEach((doc) => {
    if (doc.document === null) {
      counts++;
    }
  });
  if (typeof counts !== "number") {
    return (counts = 0);
  }
  return counts;
};

export const SELECT_REQUEST_BANK_DOCUMENTS = (state: RootState) => {
  const bankId = state.requestAppSlise.data?.bank?.bank_id;
  return (
    state.requestAppSlise.data.application_banks.find(
      (el) => el?.bank_id === bankId
    )?.documents || []
  );
};

export const SELECT_REQUEST_CHAT_DATA = (state: RootState) => {
  return state.requestAppSlise.data;
};
export const SELECT_DONT_ATTACHED_BANKS = (state: RootState) => {
  return state.requestAppSlise.data.dont_attached_banks;
};

export const SELECT_APPLICATION_FORM_VALUES = (state: RootState) => {
  return state.requestAppSlise.APPLICATION_FORM_VALUES;
};

export const SELECT_APPLICATION_STATUS = (state: RootState) => {
  return state.requestAppSlise.data.status.type;
};

export const SELECT_APPLICATION_AGENT = (state: RootState) => {
  return state.requestAppSlise.data.agent;
};

export const SELECT_APPLICATION_BANKS = (state: RootState) => {
  return state.requestAppSlise.data.banks;
};
